import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import homeicon from '../../assests/karaicon.svg';

import concept2Section1Image from '../../assests/concept2section1.png';
import concept2Section4Image from '../../assests/concept2-section4.png'; 
import concept2Section5Image from '../../assests/concept2Section5Image.png'
import concept2Section6Image from '../../assests/concept2Section6Image.jpg';
import concept2Section7Image from '../../assests/concept2-section7.png'; 
import concept2Section9Image from '../../assests/concept2-section9.png';

import concept2Section8LeftImage from '../../assests/concept2-section8-left.png';
import concept2Section8RightImage from '../../assests/concept2-section8-right.jpg';

import concept2Section10Image from '../../assests/concept2-section10.jpg'; 
import concept2Section11Image from '../../assests/concept2-section11.jpg';
import Footer from '../Footer';
// import image1 from '../../assests/concept2-img1.png';
// import image2 from '../../assests/concept2-img2.png';
// import image3 from '../../assests/concept2-img3.png';
// import image4 from '../../assests/concept2-img4.png';
// import image5 from '../../assests/concept2-img5.png';
// import image6 from '../../assests/concept2-img6.png';

import concept2Section3Image from '../../assests/concept2-section3.jpg'; 
import { ImMoveUp, ImPointDown } from 'react-icons/im';

const Concept2 = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

  const toggleConceptMenu = () => {
    setIsConceptOpen(!isConceptOpen);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handle scroll behavior
  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY;
      
      // Check if scrolled past 50px
      if (currentScrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
        setShowNavbar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', controlNavbar);

    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [lastScrollY]);

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className={`concept2-navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="concept2-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="concept2-logo-icon" />
          </Link>
        </div>
        <div className="concept2-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="concept2-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="concept2-nav-overlay">
          <div className="concept2-nav-close" onClick={toggleMenu}>
            <IoClose className="concept2-close-icon" />
          </div>
          <nav className="concept2-navigation">
            <ul className="concept2-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li className="active"><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Hero with Background Image and Bottom-Left Content */}
      <section className="concept2-section-1">
        {/* Background Image */}
        <div className="concept2-section-1-background">
          <img src={concept2Section1Image} alt="Dragonfly Dining Concept" className="concept2-section-1-bg-image" />
        </div>

        {/* Overlay */}
        <div className="concept2-section-1-overlay"></div>

        {/* Bottom Left Content */}
        <div className="concept2-section-1-content">
          <p className="concept2-section-1-label">Concept</p>
          <h1 className="concept2-section-1-title">"Dragonfly" Dining</h1>
          <h2 className="concept2-section-1-title">Dialogue</h2>
          <p className="concept2-section-1-description">
            An L-shaped teak table, grain-mapped to<br />
            echo the rhythm of a living wall
          </p>
        </div>
      </section>

      
      {/* <section className="concept2-section-2">
          <div className="concept2-section-2-container">

            <div className="concept2-section-2-row row-left">
              <div className="concept2-image-wrapper">
                <img src={image1} alt="gallery1" className="concept2-gallery-image" />
              </div>
              <div className="concept2-image-wrapper">
                <img src={image2} alt="gallery2" className="concept2-gallery-image" />
              </div>
              <div className="concept2-image-wrapper">
                <img src={image3} alt="gallery3" className="concept2-gallery-image" />
              </div>
            </div>

            <div className="concept2-section-2-row row-right">
              <div className="concept2-image-wrapper">
                <img src={image4} alt="gallery4" className="concept2-gallery-image" />
              </div>
              <div className="concept2-image-wrapper">
                <img src={image5} alt="gallery5" className="concept2-gallery-image" />
              </div>
              <div className="concept2-image-wrapper">
                <img src={image6} alt="gallery6" className="concept2-gallery-image" />
              </div>
            </div>

          </div>
      </section> */}
       


     {/* SECTION 3: Split Layout - Text Left, Image Right */}
      <section className="concept2-section-3">
        <div className="concept2-section-3-container">
          {/* Left Side - Text Content */}
          <div className="concept2-section-3-left">
            <div className="concept2-section-3-content">
              <h2 className="concept2-section-3-title">The Wing</h2>
              <p className="concept2-section-3-description">
                Teak, carved to echo the
                dragonfly's wing warm, intricate, and enduring.
              </p>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="concept2-section-3-right">
            <img 
              src={concept2Section3Image} 
              alt="The Wing - Teak carved dragonfly wing" 
              className="concept2-section-3-image" 
            />
          </div>
        </div>
      </section>


      {/* SECTION 4: Split Layout - Text Left Bottom Center, Image Right */}
      <section className="concept2-section-4">
        <div className="concept2-section-4-container">
          {/* Left Side - Text Content */}
          

          <div className="concept2-section-4-right">
            <img 
              src={concept2Section4Image} 
              alt="Ceramic Light with Dual Soul" 
              className="concept2-section-4-image" 
            />
          </div>

          {/* Right Side - Image */}
          <div className="concept2-section-4-left">
            <div className="concept2-section-4-content">
              <p className="concept2-section-4-label">Concept</p>
              <h2 className="concept2-section-4-title">Ceramic Light</h2>
              <h3 className="concept2-section-4-title">with a "Dual Soul"</h3>
              <p className="concept2-section-4-description">
                Karnataka clay, cast for light and motion,<br />
                enduring in form, eternal in craft
              </p>
            </div>
          </div>
          
        </div>
      </section>

      {/* SECTION 5: Split Layout - Image Left, Text Right Bottom */}
      <section className="concept2-section-5">
        <div className="concept2-section-5-container">

          {/* Left Side - Text Content at Bottom */}
          <div className="concept2-section-5-right">
            <div className="concept2-section-5-content">
              <p className="concept2-section-5-description">
                A dual-soul pendant wheel-thrown in Karnataka<br />
                clay, set on a 180° brass fixture for light that is both<br />
                flexible and enduring.
              </p>
            </div>
          </div>

          {/* Right Side - Full Image */}
          <div className="concept2-section-5-left">
            <img 
              src={concept2Section5Image} 
              alt="Dual Soul Pendant Light" 
              className="concept2-section-5-image" 
            />
          </div>

          
        </div>
      </section>

      {/* SECTION 6: Full Background Image with Right-Aligned Text */}
      <section className="concept2-section-6">
        {/* Background Image */}
        <div className="concept2-section-6-background">
          <img 
            src={concept2Section6Image} 
            alt="Timelessness - Crafted to Endure" 
            className="concept2-section-6-bg-image" 
          />
        </div>

        {/* Overlay */}
        <div className="concept2-section-6-overlay"></div>

        {/* Right-Aligned Content */}
        <div className="concept2-section-6-content">
          <h2 className="concept2-section-6-title">Timelessness</h2>
          <p className="concept2-section-6-description">
            Each piece is crafted to live with you, age with<br />
            you, and remain long after you.
          </p>
        </div>
      </section>

      {/* SECTION 7: Sands of Time" Prayer Partition */}
      <section className="concept2-section-4">
        <div className="concept2-section-4-container">

          {/* Left Side - Image */}
          <div className="concept2-section-4-right">
            <img 
              src={concept2Section7Image} 
              alt="Ceramic Light with Dual Soul" 
              className="concept2-section-4-image" 
            />
          </div>

          {/* Right Side - Text Content */}
          <div className="concept2-section-4-left">
            <div className="concept2-section-4-content">
              <p className="concept2-section-4-label">Concept</p>
              <h2 className="concept2-section-4-title">"Sands of Time"</h2>
              <h3 className="concept2-section-4-title">Prayer Partition</h3>
              <p className="concept2-section-4-description">
                A stained-glass veil, framing light and faith<br />
                -quiet, luminous, and eternal.
              </p>
            </div>
          </div>

          
        </div>
      </section>

      {/* SECTION 8: Split Layout - Left Content (Image + Text Center), Right Full Image */}
      <section className="concept2-section-8">
        <div className="concept2-section-8-container">
          {/* Left Side - Centered Content (Image + Text) */}
          <div className="concept2-section-8-left">
            <div className="concept2-section-8-content">
              {/* Centered Image */}
              <div className="concept2-section-8-image-wrapper">
                <img 
                  src={concept2Section8LeftImage} 
                  alt="Teak and Light Detail" 
                  className="concept2-section-8-left-image" 
                />
              </div>

              {/* Heading */}
              <h2 className="concept2-section-8-heading">Teak & Light</h2>

              {/* Description */}
              <p className="concept2-section-8-description">
                A teak and stained-glass veil shaping light, holding<br />
                stillness, and marking the quiet passage of time.
              </p>
            </div>
          </div>

          {/* Right Side - Full Image */}
          <div className="concept2-section-8-right">
            <img 
              src={concept2Section8RightImage} 
              alt="Teak and Stained Glass" 
              className="concept2-section-8-right-image" 
            />
          </div>
        </div>
      </section>

      {/* SECTION 9: Split Layout - Image Left (60%), Text Right Bottom (40%) */}
      <section className="concept2-section-9">
        <div className="concept2-section-9-container">
          {/* Left Side - Full Image (60%) */}
          <div className="concept2-section-9-left">
            <img 
              src={concept2Section9Image} 
              alt="Ceramic Light with Dual Soul" 
              className="concept2-section-9-image" 
            />
          </div>

          {/* Right Side - Text Content (40%) */}
          <div className="concept2-section-9-right">
            <div className="concept2-section-9-content">
              <p className="concept2-section-9-label">Concept</p>
              <h2 className="concept2-section-9-title">"The Weave"</h2>
              <h3 className="concept2-section-9-title">That Divides</h3>
              <p className="concept2-section-9-description">
                Custom rattan sofas that divide space with<br />
                intention, sculptural, rooted, and made to last.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 10: Full Width/Height Image */}
      <section className="concept2-section-10">
        <img 
          src={concept2Section10Image} 
          alt="The Weave Division Full View" 
          className="concept2-section-10-image" 
        />
      </section>

      {/* SECTION 11: Split Layout - Image Left, Text Right Center */}
      <section className="concept2-section-11">
        <div className="concept2-section-11-container">
          {/* Left Side - Centered Text Content (50%) */}
          <div className="concept2-section-11-right">
            <div className="concept2-section-11-content">
              <h2 className="concept2-section-11-subtitle">The Art of Quiet</h2>
              <h3 className="concept2-section-11-title">Division</h3>
              <p className="concept2-section-11-description">
                Custom rattan sofas in a 3+3+1 format, crafted in<br />
                plantation teak with handwoven backrests.<br />
                They shape two intimate lounges within an open<br />
                plan sculptural, rooted, and enduring.
              </p>
            </div>
          </div>

          {/* Right Side - Full Image (50%) */}
          <div className="concept2-section-11-left">
            <img 
              src={concept2Section11Image} 
              alt="Custom Rattan Sofas" 
              className="concept2-section-11-image" 
            />
          </div>

          
        </div>
      </section>

      <Footer/>

     

    </>
  );
};

export default Concept2;